// @ts-check
import {
  TableHead,
  TableHeader,
  TableRow,
  Text,
} from '~/design-system';
import { Trans } from '@lingui/macro';

export default function DefaultTableHeader() {
  return (
    <TableHead>
      <TableRow>
        <TableHeader sx={{ backgroundColor: 'brand.lightGray', width: 250 }}>
          <Text variant="smallest">
            <Trans>Name</Trans>
          </Text>
        </TableHeader>
        <TableHeader sx={{ backgroundColor: 'brand.lightGray', width: 250 }}>
          <Text variant="smallest">
            <Trans>User</Trans>
          </Text>
        </TableHeader>
        <TableHeader sx={{ backgroundColor: 'brand.lightGray', width: 200 }}>
          <Text variant="smallest">
            <Trans>Created</Trans>
          </Text>
        </TableHeader>
        <TableHeader
          sx={{ backgroundColor: 'brand.lightGray', width: 250 }}
        ></TableHeader>
      </TableRow>
    </TableHead>
  );
}
